// ============================================================================
// Russian UI Copy — FULL SSOT (1:1 translation of en.ts)
// Text only — NO logic, NO URLs, NO React
// ============================================================================

export const ru = {
    meta: {
      lang: 'ru',
      langFull: 'ru-RU',
      dir: 'ltr' as const,
      name: 'Русский',
    },
  
    // ─────────────────────────────────────────────────────────────
    // WORDS
    // ─────────────────────────────────────────────────────────────
  
    words: {
      dj: {
        he: `DJ`,
        he_alt: `DJ`,
        he_plain: `DJ`,
        en: `DJ`,
      },
      music: 'Музыка',
  
      mc: `DJ`,
  
      events: {
        wedding: { one: `Свадьба`, many: `Свадьбы`, to: `на свадьбу` },
        henna: { one: `Хна`, many: `Хна`, to: `на хну` },
        bar_bat: {
          one: `Бар/Бат-мицва`,
          many: `Бар/Бат-мицвы`,
          to: `на Бар/Бат-мицву`,
        },
        generic: { one: `Мероприятие`, many: `Мероприятия`, to: `на мероприятие` },
      },
  
      albums: {
        forum: `Форум`,
        articles: `Статьи`,
        recommendations: `Отзывы`,
        bars: `Бары`,
        flyers: `Флаеры`,
      },
  
      phrases: {
        music_for_events: `музыка для мероприятий`,
        company_or_private: `корпоративное / частное`,
      },
    },
  
    business: {
      name: 'DJ ELIOR MOR — Музыка для мероприятий',
  
      address: {
        street: 'Mivtsa Yoav 16',
        city: 'Be’er Sheva',
        postal: '8445914',
        country: 'IL',
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // BRAND
    // ─────────────────────────────────────────────────────────────
    brand: {
      firstName: `ELIOR`,
      short: `ELIOR MOR`,
      title: `DJ ELIOR MOR`,
    },
  
    metaDescription: {
      wedding:
        'Более 15 лет опыта на свадьбах: персональный саундтрек, точное чувство публики, профессиональные миксы и сочетание жанров, полный танцпол всю ночь — Профессиональный свадебный DJ',
  
      henna:
        'Более 15 лет опыта на хне: традиции в сочетании с современными ритмами, яркая атмосфера и полный танцпол — Профессиональный DJ на хну',
  
      barBat:
        'Более 15 лет опыта на Бар/Бат-мицвах: эмоциональный выход, музыка для подростков и взрослых, полный танцпол от начала до конца — Профессиональный DJ',
  
      generic:
        'Более 15 лет опыта на мероприятиях: музыкальное планирование, чувство публики и сочетание жанров, полный танцпол на протяжении всего вечера — Профессиональный DJ на мероприятие',
    },
  
    // ─────────────────────────────────────────────────────────────
    // HOME
    // ─────────────────────────────────────────────────────────────
  
    home: {
      title: `Музыка для мероприятий | DJ ELIOR MOR`,
  
      description:
        `ELIOR MOR — DJ с более чем 15-летним опытом работы на свадьбах, хне, Бар/Бат-мицвах и мероприятиях. ` +
        `Тонкое чувство публики, сочетание жанров и плавные миксы, которые удерживают танцпол полным и создают незабываемую музыкальную атмосферу`,
  
      heroTitle: `ELIOR MOR — Музыка для мероприятий`,
  
      sections: {
        section1Lines: (
          eventOne: string,
          mcLabel: string,
          brandTitle: string
        ) => [
          `Более 15 лет создаю идеальные ${eventOne}`,
          'Точная музыка и отличное чувство публики',
          'Профессиональный звук и плавные миксы',
          `${eventOne} с радостной и энергичной атмосферой`,
          `Плейлист, идеально подобранный под ваш ${eventOne}`,
          'Музыкальный опыт, который вы никогда не забудете',
          `${brandTitle} — ${mcLabel} для идеального ${eventOne}`,
        ],
  
        section2DescriptionSuffix: (eventOne: string) =>
          `чтобы каждое ${eventOne} стало незабываемым событием, о котором гости будут говорить ещё долго после его окончания`,
  
        section2AdditionalSuffix: '',
  
        section5SubtitleDesktop: (
          weddingOne: string,
          hennaOne: string,
          barBatOne: string,
          genericOne: string
        ) =>
          `Будь то ${weddingOne}, ${hennaOne}, ${barBatOne} или любое другое ${genericOne} — я подбираю музыку под вашу аудиторию и атмосферу, которую вы хотите создать. Благодаря точному таймингу, отличному чувству публики и грамотному сочетанию жанров вечер проходит естественно, с высокой энергией и полным танцполом`,
  
        section5SubtitleMobile: (
          weddingMany: string,
          hennaMany: string,
          barBatOne: string,
          genericMany: string,
          genericOne: string
        ) =>
          `${weddingMany}, ${hennaMany}, ${barBatOne} и корпоративные ${genericMany} — я подстраиваю музыку под вашу аудиторию и удерживаю танцпол полным до самого конца ${genericOne}.`,
  
        section6Title: (brandTitle: string) =>
          `Отзывы о ${brandTitle}`,
  
        section6Subtitle: (genericOne: string) =>
          `Что клиенты говорят о впечатлениях на танцполе? Настоящие отзывы о музыке, энергии и сопровождении от первого звонка до конца ${genericOne}`,
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 1 — OPEN
    // ─────────────────────────────────────────────────────────────
  
    section1: {
      targetPageLines: {
        base: [
          'Более 15 лет опыта на всех типах мероприятий',
          'Музыка, построенная вокруг энергии вашей аудитории',
          'Точное чувство публики и неотразимая атмосфера танца',
          'Полный танцпол до поздней ночи',
        ],
  
        wedding: [
          'Более 15 лет опыта на свадьбах',
          'Музыка, подобранная для каждого свадебного момента',
          'Персональный саундтрек, созданный специально для вас',
          'Плавные миксы и отличное чувство публики',
          'Полное музыкальное планирование и профессиональное сопровождение',
          'Свадьба, о которой гости будут говорить ещё очень долго',
        ],
  
        henna: [
          'Эмоциональное празднование хны с подлинной атмосферой',
          'Яркая, радостная атмосфера',
          'Идеальное сочетание традиции и современных ритмов',
          'Барабаны и ритмы, которые заряжают всю семью',
          'Плейлист, адаптированный именно под вашу хну',
          'Эмоциональная церемония хны с зажигательной атмосферой',
        ],
  
        bar_bat: [
          'Более 15 лет опыта на Бар/Бат-мицвах',
          'Запоминающийся торжественный выход',
          'Полный танцпол с первой песни до последней',
          'Актуальные хиты, которые любят подростки и взрослые',
          'Радостная семейная атмосфера',
          'Музыкальный опыт, который остаётся в памяти',
        ],
  
        event: [
          'Более 15 лет опыта на всех типах мероприятий',
          'Точная музыка и отличное чувство публики',
          'Профессиональный звук и плавные миксы',
          'Энергичная и радостная атмосфера мероприятия',
          'Плейлист, точно адаптированный под ваше мероприятие',
          'Музыкальный опыт, который вы никогда не забудете',
        ],
      },
      hub: {
        city: {
          descriptionLines: (
            keyword: string,
            cityBet: string,
            brandTitle: string
          ) => [
            'Более 15 лет опыта, который говорит сам за себя',
            'Музыка, адаптированная под любой тип аудитории',
            'Умение чувствовать танцпол и поставить идеальный трек',
            'Радостная атмосфера от начала и до конца мероприятия',
            `${brandTitle} — ${keyword}${cityBet}`,
          ],
  
          extraHeadings: (keyword: string, cityBet: string) => [
            `Как правильно выбрать ${keyword}${cityBet}`,
            `Популярные типы мероприятий${cityBet}`,
          ],
        },
  
        region: {
          descriptionLines: (
            keyword: string,
            regionBet: string,
            brandTitle: string
          ) => [
            'Более 15 лет опыта, который говорит сам за себя',
            'Разнообразная музыка, подходящая для любой аудитории',
            'Танцпол, наполненный энергией и радостью',
            'Праздничная атмосфера, которая длится весь вечер',
            `${brandTitle} — ${keyword}${regionBet}`,
          ],
  
          extraHeadings: (keyword: string, regionBet: string) => [
            `Как выбрать ${keyword}${regionBet}`,
            `Лучшие города${regionBet}, с которых стоит начать поиск`,
          ],
        },
  
        home: {
          section1Lines: (
            eventOne: string,
            mcLabel: string,
            brandTitle: string
          ) => [
            `Более 15 лет опыта, обеспечивающего идеальное ${eventOne}`,
            'Точная музыка и отличное чувство публики',
            'Профессиональный звук и плавные миксы',
            `${eventOne} с радостной и энергичной атмосферой`,
            `Плейлист, идеально подобранный под ваше ${eventOne}`,
            'Музыкальный опыт, который вы никогда не забудете',
            `${brandTitle} — ${mcLabel} для идеального ${eventOne}`,
          ],
        },
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 2 — ABOUT
    // ─────────────────────────────────────────────────────────────
  
    section2: {
      title: 'Моя история',
      description:
        `Более 15 лет за DJ-пультом, включая десятилетие в роли резидент-DJ клуба Forum — я, ELIOR MOR, создаю нужную энергию, точно чувствую публику и подбираю музыку, которая удерживает танцпол живым с первой и до последней песни.`,
      additionalText:
        'Для меня каждое мероприятие — это возможность зарядить танцпол энергией и создать незабываемые моменты. Я чувствую публику, сочетаю жанры и удивляю треками, которые вы не слышали много лет — превращая ваше мероприятие в событие совершенно другого уровня',
  
      imageAltPortrait: `ELIOR MOR за DJ-пультом`,
      imageAltHorizontal: `ELIOR MOR — DJ, который умеет зажечь вечеринку`,
  
      targetAdditionalByService: {
        wedding:
          'Свадьба — это история любви, оживающая через музыку. Я начинаю с настоящего знакомства с вами — кто вы, что вас вдохновляет и какой вы представляете свою свадьбу. Затем мы вместе создаём персональный саундтрек, оттачиваем каждый момент и формируем атмосферу, чтобы воплотить вашу мечту в реальность',
  
        henna:
          'Каждое празднование хны — это яркая вечеринка, которую я тщательно выстраиваю с самого первого момента. Моя цель проста — радостная атмосфера, ритмы, которые поднимают всех, и полный танцпол. Я сочетаю традицию с современными битами, чтобы создать неудержимую энергию',
  
        bar_bat:
          'Каждая Бар/Бат-мицва — это возможность создать особенные моменты, которые объединяют всех. Моя цель проста — вечеринка, которая естественно ощущается для подростков и при этом нравится взрослым. Благодаря правильному балансу современных хитов и вечной классики результатом становится энергичное празднование, частью которого чувствует себя каждый',
  
        event:
          'Каждое мероприятие — это возможность создать точный музыкальный опыт, адаптированный под аудиторию и формат события. Благодаря чувству публики в реальном времени, плавным переходам и умному сочетанию жанров атмосфера остаётся энергичной весь вечер',
      },
  
      targetAdditionalSuffixByService: {
        wedding:
          'Я придаю вашей свадьбе личный характер и точность, которые ощущаются в каждом моменте',
  
        henna:
          'Я добавляю особый штрих, который превращает вашу хну в живой и энергичный праздник',
  
        bar_bat:
          'Я создаю музыкальную идентичность, идеально подходящую именно вашей семье и атмосфере',
  
        event:
          'Я точно настраиваю музыку так, чтобы каждое мероприятие получало свой уникальный характер',
      },
  
      fallbackSuffix:
        'Так ваше мероприятие получает атмосферу, идеально подходящую вашей аудитории',
  
      targetDescription: (
        baseDescription: string,
        djKeyword: string,
        cityBet: string
      ) =>
        `${baseDescription} Я ${djKeyword}${cityBet}, прекрасно знакомый с местной аудиторией и площадками в этом районе`,
  
      targetAdditionalText: (
        base: string,
        cityBet: string,
        suffix: string
      ) => `${base} ${cityBet} ${suffix}`.replace(/\s+/g, ' ').trim(),
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 3 — GALLERY
    // ─────────────────────────────────────────────────────────────
  
    section3: {
      title: 'Пусть фотографии говорят сами за себя',
      fallbackText: 'Выберите альбом, чтобы увидеть больше деталей',
      albumsError: 'Не удалось загрузить альбомы. Пожалуйста, попробуйте позже.',
      filesError: 'Ошибка загрузки файлов.',
      loading: 'Загрузка галереи…',
  
      galleryHeadings: {
        wedding: (keyword: string, cityBet: string) => [
          `Фотографии свадеб${cityBet} — церемония, первый танец и танцпол`,
          `Свадебные моменты${cityBet} — энергия на танцполе`,
          `Счастливые пары и зажигательные сеты — свадьбы${cityBet}`,
        ],
  
        henna: (_keyword: string, cityBet: string) => [
          `Галерея хны${cityBet} — цвет, круги и ритм`,
          `Традиция и радость — праздники хны${cityBet}`,
          `Барабаны и энергия — настоящие моменты хны${cityBet}`,
        ],
  
        bar_bat: (_keyword: string, cityBet: string) => [
          `Бар/Бат-мицва${cityBet} — выход, танцпол и атмосфера`,
          `Подростки и семьи танцуют — Бар/Бат-мицва${cityBet}`,
          `Пиковые моменты и живые фото — Бар/Бат-мицва${cityBet}`,
        ],
  
        event: (_keyword: string, cityBet: string) => [
          `Лучшие моменты мероприятий${cityBet} — полные танцполы`,
          `Музыкальный стиль и энергия — мероприятия${cityBet}`,
          `Галерея мероприятий${cityBet} — незабываемые моменты`,
        ],
      },
  
      albumDescriptions: {
        weddings:
          'Фотографии с настоящих свадеб — церемония, первый танец и зажигательный танцпол. Атмосфера, которая поднимает каждого гостя от начала до конца',
  
        hennas:
          'Цвет, барабаны и круги — праздники хны, полные энергии и радости, где традиция сочетается с современными вибрациями',
  
        barBat:
          'Моменты с Бар/Бат-мицв — торжественный выход, подростковый танцпол и зажигательная атмосфера, объединяющая всех',
  
        forum:
          'Энергичные сеты из клуба Forum в Беэр-Шеве, где я был резидент-DJ в течение десяти лет. Атмосфера 3000 тусовщиков каждые выходные',
  
        articles:
          'Подборка публикаций в СМИ, интервью и материалов — истории, стоящие за музыкой',
  
        recommendations:
          'Настоящие отзывы клиентов — обратная связь, сообщения и благодарности после незабываемых вечеров',
  
        bars:
          'Сеты из баров по всей стране — точная музыка под каждую аудиторию и энергичные ночи',
  
        flyers:
          'Подборка афиш клубов и мероприятий — каждая рассказывает историю запоминающейся ночи',
      },
  
      albumTexts: {
        weddings:
          'Фотографии с настоящих свадеб — церемония, первый танец и зажигательный танцпол. Атмосфера, которая поднимает каждого гостя от начала до конца',
  
        hennas:
          'Цвет, барабаны и круги — праздники хны, полные энергии и радости, где традиция сочетается с современными вибрациями',
  
        barBat:
          'Моменты с Бар/Бат-мицв — торжественный выход, подростковый танцпол и зажигательная атмосфера, объединяющая всех',
  
        forum:
          'Энергичные сеты из клуба Forum в Беэр-Шеве, где я был резидент-DJ в течение десяти лет. Атмосфера 3000 тусовщиков каждые выходные',
  
        articles:
          'Подборка публикаций в СМИ, интервью и материалов — истории, стоящие за музыкой',
  
        recommendations:
          'Настоящие отзывы клиентов — обратная связь, сообщения и благодарности после незабываемых вечеров',
  
        bars:
          'Сеты из баров по всей стране — точная музыка под каждую аудиторию и энергичные ночи',
  
        flyers:
          'Подборка афиш клубов и мероприятий — каждая рассказывает историю запоминающейся ночи',
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 4 — CONTACT / CTA
    // ─────────────────────────────────────────────────────────────
  
    section4: {
      title: 'Прокачай своё мероприятие',
  
      description:
        'Ищете DJ для вашего мероприятия?\nЗдесь вы найдете идеальное сочетание опыта, энергии и музыки',
  
      groupTitles: {
        contact: 'Контакт',
        events: 'Категории мероприятий',
        services: 'Дополнительные услуги',
      },
      eventsIntro: {
        default: `Музыка, адаптированная под любой тип мероприятия — частный или корпоративный`,
  
        wedding: (keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `${keyword}${loc} — от церемонии до вечеринки, музыка, идеально подобранная под вас и ваших гостей`;
        },
  
        henna: (keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `${keyword}${loc} — традиционные ритмы в сочетании с современными битами для яркого семейного праздника`;
        },
  
        bar_bat: (keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `${keyword}${loc} — актуальные хиты рядом с любимой вечной классикой`;
        },
  
        event: (keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `Индивидуально подобранная музыка для любого вида мероприятия, частного или корпоративного`;
        },
      },
      servicesIntro: {
        wedding: (_keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `Дополнения к свадьбе${loc}: свадебный свет, профессиональный звук и аттракции.`;
        },
  
        henna: (_keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `Дополнения к хне${loc}: барабанщики, тёплый свет и аттракции`;
        },
  
        bar_bat: (_keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `Дополнения к Бар/Бат-мицве${loc}: свет, качественный звук и аттракции`;
        },
  
        event: (_keyword: string, cityBet: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
          return `Дополнения к мероприятию${loc}: свет, звук и аттракции, подходящие для любого формата`;
        },
      },
      eventsTexts: {
        wedding: (cityBet: string) =>
          `Свадебный DJ${cityBet} — музыка, идеально подобранная для пары и гостей`,
  
        henna: (cityBet: string) =>
          `DJ на хну${cityBet} — подлинная традиция в сочетании с современными битами`,
  
        bar_bat: (cityBet: string) =>
          `DJ на Бар/Бат-мицву${cityBet} — хиты для всех поколений`,
  
        event: (cityBet: string) =>
          `DJ на мероприятие${cityBet} — корпоративное или частное, под любой стиль`,
      },
      groupTitlesSeo: {
        wedding: (keyword: string, cityBet: string, brand: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
  
          return {
            contact: `Связаться с ${brand}`,
            events: `Другие категории мероприятий${loc}`,
            services: `Дополнительные свадебные услуги${loc}`,
            links: `Связанные страницы для ${keyword}${loc}`,
          };
        },
  
        henna: (keyword: string, cityBet: string, brand: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
  
          return {
            contact: `Связаться с ${brand}`,
            events: `Другие мероприятия, на которых я выступаю${loc}`,
            services: `Дополнительные услуги для хны${loc}`,
            links: `Связанные страницы для ${keyword}${loc}`,
          };
        },
  
        bar_bat: (keyword: string, cityBet: string, brand: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
  
          return {
            contact: `Связаться с ${brand}`,
            events: `Популярные категории мероприятий${loc}`,
            services: `Дополнения к Бар/Бат-мицве${loc}`,
            links: `Связанные страницы для ${keyword}${loc}`,
          };
        },
  
        event: (keyword: string, cityBet: string, brand: string) => {
          const loc = cityBet ? ` ${cityBet.trim()}` : '';
  
          return {
            contact: `Связаться с ${brand}`,
            events: `Типы мероприятий, которые я провожу${loc}`,
            services: `Дополнительные услуги для мероприятий${loc}`,
            links: `Связанные страницы для ${keyword}${loc}`,
          };
        },
      },
      contactSeo: {
        phone: `Позвоните мне — я с радостью отвечу на любой вопрос.`,
        whatsapp: `Напишите в WhatsApp, и я скоро вам отвечу.`,
        email: `Вы также можете написать по email — отправьте сообщение, и я скоро отвечу.`,
        instagram: `Посмотрите Instagram — живые видео и фото с танцпола.`,
        facebook: `На Facebook вы найдете отзывы и реальные моменты с мероприятий.`,
        navigate: `До меня легко добраться — нажмите для навигации в Google Maps.`,
      },
      contactButtons: {
        phone: 'Позвонить',
        whatsapp: 'WhatsApp',
        email: 'Email',
        instagram: 'Instagram',
        facebook: 'Facebook',
        navigate: 'Навигация',
      },
      prefills: {
        wedding:
          'Привет, Elior,\nЯ бы хотел(а) получить информацию о свадебном DJ.',
        henna:
          'Здравствуйте, Elior,\nМеня интересует DJ на хну.',
        barBat:
          'Привет,\nИщу DJ на Бар/Бат-мицву — можете прислать подробности?',
        generic:
          'Здравствуйте,\nЯ ищу DJ для корпоративного/частного мероприятия.',
      },
      blockCopy: {
        withCity: (
          keyword: string,
          cityName: string,
          firstName: string
        ) => ({
          description:
            `Ищете ${keyword} в ${cityName}?\nЗдесь вы найдете идеальное сочетание опыта, энергии и музыки`,
  
          whatsappPrefill:
            `Привет ${firstName}, меня интересует ${keyword} в ${cityName}`,
  
          linksHeading:
            `Связанные страницы для ${keyword} в ${cityName}`,
        }),
  
        withoutCity: (
          keyword: string,
          eventName: string,
          firstName: string
        ) => ({
          description:
            `Ищете DJ для вашего ${eventName}?\nЗдесь вы найдете идеальное сочетание опыта, энергии и музыки`,
  
          whatsappPrefill:
            `Привет ${firstName}, меня интересует DJ для моего ${eventName}`,
  
          linksHeading:
            `Связанные страницы для DJ`,
        }),
      },
      services: {
        sound: {
          label: 'Звуковая система',
          description: 'Профессиональный звук — чистое и качественное аудио в любом пространстве.',
        },
        light: {
          label: 'Свет',
          description: 'Динамическое освещение — преображает любой танцпол.',
        },
        attractions: {
          label: 'Аттракции',
          description: 'Эффекты для мероприятия — конфетти, тяжёлый дым, шары и многое другое.',
        },
        recording: {
          label: 'Запись',
          description: 'Услуги записи — первый танец, благословения или особые выходы.',
        },
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 5 — FAQ INTRO
    // ─────────────────────────────────────────────────────────────
  
    section5: {
      title: 'Подробнее',
      linksHeading: 'Страницы, которые стоит посмотреть',
      subtitle:'Ответы на частые вопросы о музыке, планировании и всём, что связано с вашим мероприятием.',
      moreLink: 'Читать больше вопросов',
      headingsSeo: {
        wedding: (keyword: string, cityBet: string) => [
          `Музыкальное планирование свадеб${cityBet} от первого звонка до последней песни.`,
          `Элегантная музыка на велком, создающая идеальную атмосферу.`,
          `Полное сопровождение церемонии с точным выбором песен.`,
          `Музыка для выхода жениха, выхода невесты и момента разбивания бокала.`,
          `Плавный переход от церемонии к открытию танцев.`,
          `Эмоциональный медленный танец, подобранный под пару.`,
          `Музыкальные стили, адаптированные к каждому этапу вечера.`,
          `${keyword}${cityBet}, который сопровождает вас до самого конца ночи.`,
          `Энергичный танцпол, который удерживает улыбки гостей.`,
        ],
  
        henna: (keyword: string, cityBet: string) => [
          `Планирование праздника хны${cityBet} в соответствии с семейными традициями.`,
          `Музыка, создающая радостную и яркую атмосферу.`,
          `Торжественный выход с барабанами и процессией.`,
          `Традиционная танцевальная музыка для всех поколений.`,
          `Музыка для ключевых моментов церемонии хны.`,
          `Музыка для обмена подарками и семейных кругов.`,
          `Сбалансированное сочетание традиции и современных битов.`,
          `${keyword}${cityBet}, который приносит подлинную энергию в праздник.`,
        ],
  
        bar_bat: (keyword: string, cityBet: string) => [
          `Планирование Бар/Бат-мицвы${cityBet} с музыкой для подростков и взрослых.`,
          `Лёгкая музыка на велком для прихода гостей.`,
          `Торжественный выход, согласованный с выбранной песней.`,
          `Музыка для речей, презентаций и трогательных моментов.`,
          `Энергичные танцевальные сеты для молодёжи.`,
          `Сбалансированная музыка, подходящая для всех возрастов.`,
          `Интерактивные моменты и специальные выступления.`,
          `${keyword}${cityBet}, который удерживает танцпол полным всю ночь.`,
        ],
  
        event: (
          keyword: string,
          cityBet: string,
          hasCity: boolean
        ) => {
          if (!hasCity) {
            return [
              `Каждое мероприятие начинается с понимания вашей аудитории.`,
              `Музыкальное планирование для велкома, официальных моментов и вечеринки.`,
              `Саундтрек, адаптированный под тип мероприятия.`,
              `Эмоциональная музыка для особых моментов.`,
              `Постепенное наращивание энергии к танцам.`,
              `Плавные переходы, которые ощущаются естественно.`,
              `Профессиональный звук, подходящий под размер площадки.`,
              `${keyword}, создающий тёплый и незабываемый вечер.`,
            ];
          }
  
          return [
            `Планирование мероприятия${cityBet}, адаптированное под вашу аудиторию и площадку.`,
            `Музыка на велком, создающая настроение.`,
            `Музыка для речей, презентаций и церемоний.`,
            `Постепенный переход к энергии танцпола.`,
            `Чувство публики в реальном времени на протяжении всего вечера.`,
            `Звук, откалиброванный под площадку.`,
            `${keyword}${cityBet}, который сопровождает вас весь вечер.`,
            `Гости уходят с яркими воспоминаниями.`,
          ];
        },
      },
      eventTypeDescription: {
        wedding: {
          mobile: (_city: string, cityBet: string) =>
            `Музыка вашей свадьбы${cityBet} строится вокруг истории и атмосферы, которую вы хотите — от приветственного велкома, через церемонию и эмоциональные моменты, до энергичной вечеринки, объединяющей всех гостей.`,
  
          desktop: (_city: string, cityBet: string) =>
            `Чтобы превратить вашу свадьбу${cityBet} в незабываемое событие, я создаю персональный саундтрек, адаптированный под каждый этап мероприятия — от элегантной музыки на велкоме, через церемонию и трогательные моменты, до яркой вечеринки, объединяющей всех гостей на танцполе.`,
        },
        event: {
          mobile: (_city: string, cityBet: string) =>
            `На каждом мероприятии${cityBet} музыкальный стиль подбирается под аудиторию. Плавные переходы, разнообразные плейлисты и сильная энергия удерживают всех в танце.`,
  
          desktop: (_city: string, cityBet: string) =>
            `На каждом мероприятии${cityBet} я подстраиваю звук и музыкальный стиль под аудиторию и формат события. Благодаря правильному сочетанию хитов, классики и точных переходов атмосфера остаётся энергичной до самой последней песни.`,
        },
        bar_bat: {
          mobile: (_city: string, cityBet: string) =>
            `Бар/Бат-мицва${cityBet} — это праздник, который бывает раз в жизни. Я сочетаю актуальные хиты для подростков с классикой, любимой всей семьёй.`,
  
          desktop: (_city: string, cityBet: string) =>
            `Бар/Бат-мицва${cityBet} — это уникальный праздник. Я соединяю современные молодёжные хиты с вечной музыкой для вечеринок всех поколений, создавая энергичную и радостную атмосферу.`,
        },
        henna: {
          mobile: (_city: string, cityBet: string) =>
            `Праздник хны${cityBet} — это яркая традиция. Подлинная музыка, современные биты, барабаны и круги создают мощную энергию.`,
  
          desktop: (_city: string, cityBet: string) =>
            `Праздник хны${cityBet} сочетает традицию с яркой энергией вечеринки. Подлинные ритмы, современные биты и живые элементы создают радостную семейную атмосферу.`,
        },
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SECTION 6 — REVIEWS
    // ─────────────────────────────────────────────────────────────
  
    section6: {
      title: 'Отзывы и рекомендации',
  
      subtitle:
        'Что клиенты говорят о впечатлениях на танцполе, энергии и сервисе',
  
      aggregateText: 'На основе реальных отзывов',
  
      readMore: 'Читать все отзывы',
  
      linkText: 'На полную страницу отзывов',
      defaults: {
        title: (brandTitle: string) =>
          `Отзывы и рекомендации о ${brandTitle}`,
  
        subtitle: (
          brandShort: string,
          keyword: string,
          cityBet: string
        ) =>
          `Что клиенты говорят о ${brandShort}?\nНастоящие отзывы о ${keyword}${cityBet} — энергия на танцполе, чувство публики и профессиональный сервис.`,
      },
      reviewsCount: (count: number) =>
        `На основе ${count} отзывов`,
  
    },
  
    misc: {
      professional: 'Профессиональный',
      recommended: 'Рекомендуемый',
    },
  
    // ─────────────────────────────────────────────────────────────
    // FOOTER
    // ─────────────────────────────────────────────────────────────
  
    footer: {
      copyright: (year: number) =>
        `© ${year} DJ ELIOR MOR — Все права защищены`,
      recommendedPages: 'Рекомендуемые страницы',
      accessibilityStatement: 'Заявление о доступности',
    },

    planning: {
      readMoreLabel: 'Полный гид',
      previousLabel: 'Назад',
      nextLabel: 'Вперёд',
      backHomeLabel: 'Назад',
      articleEyebrow: (service: string) => `${service} - гид по планированию`,
      contactTitle: 'Хотите правильно спланировать музыку?',
      contactButtonLabel: 'Связаться',
      whatsappLabel: 'WhatsApp',
      phoneLabel: 'Позвонить',
      parentLinkLabel: (serviceLabel: string) => `Страница ${serviceLabel}`,
      parentContext: (articleTitle: string, serviceLabel: string) => ({
        before: `Чтобы ${articleTitle} правильно вписался во весь вечер, стоит также посмотреть страницу `,
        linkLabel: serviceLabel,
        after: ' и собрать музыку, тайминг, эффекты и переходы в один понятный план.',
      }),
      whatsappText: (articleTitle: string) =>
        `Здравствуйте, Элиор. Я прочитал(а) гид "${articleTitle}" на сайте и хочу посоветоваться по музыкальному планированию события.`,
      trustTitle: 'Как превратить это в реальный план события',
      trustParagraphs: (articleTitle: string, serviceLabel: string, brandShort: string) => [
        `${articleTitle} — это не просто пункт в списке. На реальном событии он должен соединяться с публикой, площадкой, семьёй, временем и всей музыкальной логикой вечера.`,
        `Опыт ${brandShort} помогает понять, где нужен эмоциональный момент, где стоит поднять темп, а где короткий переход работает лучше большого эффекта.`,
        `Перед событием я уточняю состав гостей, важные стили, песни, которые не подходят, и моменты, которые должны быть точными. Так план становится личным и профессиональным.`,
      ],
      workTitle: 'Что я проверяю с вами перед финальным планом',
      workBullets: [
        'Порядок события и переходы между встречей гостей, церемонией, едой и танцполом.',
        'Обязательные песни, нежелательные песни и любимые стили.',
        'Подход к аудитории: семья, друзья, молодёжь, взрослые или деловая публика.',
        'Координация с площадкой, поставщиками, музыкантами, аттракциями и звуком.',
      ],
    carouselLabel: (title: string) => `${title} - гиды`,
    guideTitle: 'Гид по планированию мероприятий',
    guideSubtitle: 'Все гиды по планированию свадеб, хины, бар/бат-мицвы, частных и деловых мероприятий в одном месте.',
    relatedTitle: 'Другие полезные гиды',
    faqTitle: 'Частые вопросы',
    authorTitle: 'Написано на основе реального опыта',
    authorText: 'Этот материал основан на более чем 15 годах опыта на свадьбах, хинах, бар/бат-мицвах и мероприятиях. Цель — дать практические советы, а не общие идеи.',
      sections: {
        חתונה: { title: 'Планирование свадьбы', subtitle: 'Короткие гиды по главным музыкальным моментам: хупа, slow dance и тайминг вечера.', keys: ['wedding_chuppah_song', 'wedding_timeline', 'wedding_attractions', 'wedding_musicians', 'wedding_slow_song', 'wedding_music'] },
        חינה: { title: 'Планирование хины', subtitle: 'Идеи для музыки на хину с уважением к традиции, семье и энергии танцпола.', keys: ['henna_entrance', 'henna_timeline', 'henna_attractions', 'henna_musicians', 'henna_music', 'henna_moroccan', 'henna_kurdish', 'henna_tunisian', 'henna_yemenite', 'henna_indian', 'henna_iraqi', 'henna_persian'] },
        'בר-מצווה': { title: 'Планирование бар/бат-мицвы', subtitle: 'Гиды для входа, записанных песен и музыкальных моментов для подростков и семьи.', keys: ['bar_bat_entrance', 'bar_bat_timeline', 'bar_bat_attractions', 'bar_bat_musicians', 'bar_bat_recording', 'bar_bat_music'] },
        אירוע: { title: 'Планирование события', subtitle: 'Простые инструменты для музыки, тайминга и атмосферы частных и деловых событий.', keys: ['event_entrance', 'event_music', 'event_music_timeline', 'event_attractions', 'event_musicians'] },
      },
      articles: {
        wedding_chuppah_song: { title: 'Выбор песни для входа к хупе', sectionTitle: 'Как выбрать песню для входа к хупе', description: 'Песня для входа к хупе должна быть личной, эмоциональной и точно рассчитанной по времени.', imageAlt: 'Пара входит к хупе под трогательную музыку', intro: 'Хорошая песня должна подходить вам, темпу входа, месту церемонии и эмоции, которую вы хотите оставить гостям.', bullets: ['Выберите песню, которая ощущается вашей.', 'Проверьте, что начало хорошо работает.', 'Подберите длину под расстояние входа.', 'Согласуйте старт и переход с DJ.'], cta: 'Хотите точный и трогательный вход к хупе? Спланируем его вместе.' },
        wedding_timeline: { title: 'Тайминг свадьбы', sectionTitle: 'Как построить тайминг свадьбы', description: 'Чёткий тайминг соединяет встречу гостей, хупу, slow dance и танцпол.', imageAlt: 'План музыкального тайминга свадьбы', intro: 'Тайминг помогает всем поставщикам понимать, когда происходит каждый момент.', bullets: ['Определите время хупы и танцев.', 'Оставьте запас на задержки.', 'Отметьте главные моменты.', 'Согласуйте переходы с DJ.'], cta: 'Хороший тайминг держит свадьбу в правильном ритме.' },
        wedding_attractions: { title: 'Аттракции для свадьбы', sectionTitle: 'Как выбрать свадебные аттракции', description: 'Аттракции должны добавлять впечатление, не мешая танцполу.', imageAlt: 'Свадебные аттракции на танцполе', intro: 'Фото-зоны, эффекты и сюрпризы работают лучше всего при точном тайминге.', bullets: ['Выбирайте по аудитории.', 'Не блокируйте танцпол.', 'Согласуйте время с DJ.', 'Лучше меньше, но точнее.'], cta: 'Аттракции могут усилить праздник, если они встроены правильно.' },
        wedding_musicians: { title: 'Музыканты на свадьбу', sectionTitle: 'Когда добавить живых музыкантов', description: 'Живые музыканты добавляют эмоцию на встрече гостей, хупе или старте танцев.', imageAlt: 'Живые музыканты на свадебной встрече гостей', intro: 'Саксофон, скрипка или перкуссия должны быть согласованы с DJ.', bullets: ['Выберите правильный момент.', 'Согласуйте песни.', 'Проверьте звук.', 'Держите выступление точным.'], cta: 'Правильные музыканты оживляют ключевые моменты.' },
        wedding_slow_song: { title: 'Выбор песни для slow dance', sectionTitle: 'Как выбрать slow dance для свадьбы', description: 'Песня для slow dance должна быть интимной, естественной и не выглядеть вынужденно.', imageAlt: 'Свадебный танцпол во время slow dance', intro: 'Slow dance короткий, но при правильном планировании он запоминается. Песня должна подходить вам и уровню драматичности.', bullets: ['Выберите песню, которую любите.', 'Не берите слишком длинную песню.', 'Решите, присоединятся ли семья и друзья.', 'Попросите короткую версию при необходимости.'], cta: 'Подберём песню и структуру вместе.' },
        wedding_music: { title: 'Выбор музыки для свадьбы', sectionTitle: 'Как выбрать музыку для свадьбы', description: 'Свадебная музыка должна соединить пару, друзей и обе семьи правильным миксом стилей.', imageAlt: 'DJ планирует музыку для свадьбы', intro: 'На свадьбе есть встреча гостей, хупа, slow dance, танцпол и after party. Начните с аудитории: молодые друзья, старшая семья, религиозные гости, мизрахи, израильская, латина, хип-хоп, ностальгия, транс, техно и любимые группы.', bullets: ['Разделите гостей по возрасту, семье и традиции.', 'Запишите любимых артистов, группы и стили.', 'Оставьте DJ место читать танцпол.', 'Постройте переход от приёма к поздней энергии.'], cta: 'Хороший саундтрек сочетает ваш вкус и профессиональное чтение публики.' },
        henna_entrance: { title: 'Вход на хину', sectionTitle: 'Как спланировать вход на хину', description: 'Вход должен открыть вечер цветом, семьёй и правильным ритмом.', imageAlt: 'Праздничный вход на хину', intro: 'Важно заранее понять, кто входит, под какую песню и как перейти к церемонии.', bullets: ['Выберите песню по традиции.', 'Определите порядок входа.', 'Добавляйте барабаны только по делу.', 'Подготовьте переход к церемонии.'], cta: 'Сильный вход поднимает семью с первой минуты.' },
        henna_timeline: { title: 'Тайминг хины', sectionTitle: 'Как построить тайминг хины', description: 'Тайминг соединяет вход, церемонию, наряды и танцы.', imageAlt: 'План тайминга хины', intro: 'В хине много семейных моментов, поэтому порядок должен быть ясным.', bullets: ['Запланируйте вход и церемонию.', 'Оставьте время на благословения.', 'Решите, где поднять темп.', 'Избегайте лишних пауз.'], cta: 'Точный тайминг сохраняет традицию и энергию.' },
        henna_attractions: { title: 'Аттракции для хины', sectionTitle: 'Как выбрать аттракции для хины', description: 'Аттракции должны усиливать цвет и традицию без перегруза.', imageAlt: 'Цветные аттракции на хине', intro: 'Наряды, барабаны и фото-зоны работают, когда они встроены в ход вечера.', bullets: ['Подбирайте к традиции семьи.', 'Оставьте место для танцев.', 'Согласуйте момент включения.', 'Назначьте ответственного.'], cta: 'Правильные аттракции добавляют цвет, не останавливая праздник.' },
        henna_musicians: { title: 'Музыканты для хины', sectionTitle: 'Живые музыканты на хине', description: 'Музыканты добавляют аутентичный ритм входу, церемонии и кругам.', imageAlt: 'Музыканты и барабаны на хине', intro: 'Барабаны, певец или традиционные инструменты должны работать вместе с DJ.', bullets: ['Выберите музыкантов по стилю.', 'Согласуйте ритмы.', 'Проверьте звук.', 'Сохраняйте баланс с танцполом.'], cta: 'Живые музыканты дают хине тёплый семейный звук.' },
        henna_music: { title: 'Выбор музыки для хины', sectionTitle: 'Как выбрать музыку для хины', description: 'Музыка для хины должна уважать традицию и открывать радостный танцпол.', imageAlt: 'Выбор музыки для хины', intro: 'Начните с семейной традиции: марокканская, йеменская, персидская, иракская, курдская, тунисская, индийская или смешанная, а затем соедините её с мизрахи, израильской, латиной, хип-хопом, ностальгией и актуальной танцевальной музыкой.', bullets: ['Соберите важные семейные и этнические песни.', 'Учитывайте молодых, старших и религиозных гостей.', 'Смешайте аутентику и современную энергию.', 'Спланируйте переход от церемонии к вечеринке.'], cta: 'Хина должна звучать как ваша семья и поднимать весь зал.' },
        henna_moroccan: { title: 'Марокканская хина', sectionTitle: 'Как спланировать радостную марокканскую хину', description: 'Цветная хина с традицией, ритмом и живым танцполом.', imageAlt: 'Весёлый танцпол на марокканской хине', intro: 'Музыка должна уважать церемонию и традицию, но также открывать современный танцпол.', bullets: ['Спланируйте входы и смену нарядов.', 'Смешайте марокканские ритмы с хитами.', 'Оставьте место семейным песням.', 'Согласуйте ключевые моменты с DJ.'], cta: 'Создадим саундтрек, который знает традицию и поднимает танцпол.' },
        henna_kurdish: { title: 'Курдская хина', sectionTitle: 'Музыкальное планирование курдской хины', description: 'Семейное тепло, традиционные ритмы и настоящая вечеринка.', imageAlt: 'Семейный праздник на курдской хине', intro: 'Важно, чтобы семья чувствовала себя дома, а гости могли легко присоединиться к танцполу.', bullets: ['Соберите важные традиционные песни.', 'Постройте ясный ход церемонии.', 'Смешайте круги и знакомые хиты.', 'Оставьте место семейным просьбам.'], cta: 'Спланируем музыку с уважением к традиции и живой энергией.' },
        henna_tunisian: { title: 'Тунисская хина', sectionTitle: 'Как построить тунисскую хину в правильном темпе', description: 'Церемония, семья и радость с музыкой, которая держит вечер.', imageAlt: 'Музыка и танцы на тунисской хине', intro: 'Лучший результат получается, когда традиционные моменты и праздник текут естественно.', bullets: ['Подготовьте обязательные семейные песни.', 'Определите время благословений и входов.', 'Смешайте тунисские ритмы и актуальные песни.', 'Держите переходы короткими.'], cta: 'Спланируем семейные моменты и танцпол вместе.' },
        henna_yemenite: { title: 'Йеменская хина', sectionTitle: 'Планирование йеменской хины с радостной музыкой', description: 'Дайте традиции место и продолжите вечер энергичной вечеринкой.', imageAlt: 'Йеменская хина с музыкой и танцами', intro: 'Правильный план помогает перейти от традиции к современному танцполу без потери характера.', bullets: ['Выберите песни для входа и церемонии.', 'Решите, когда начинается вечеринка.', 'Смешайте йеменские, мизрахи и современные хиты.', 'Проверьте звук для церемонии и танцев.'], cta: 'Аутентично и энергично может работать вместе.' },
        henna_indian: { title: 'Индийская хина', sectionTitle: 'Как спланировать яркую индийскую хину', description: 'Индийская хина соединяет цвет, наряды, семейную церемонию и радостную музыку.', imageAlt: 'Яркая индийская хина с музыкой и танцами', intro: 'Хороший план соединяет традицию, входы, наряды и танцпол, который понятен всей аудитории.', bullets: ['Выберите песни для входа и церемонии.', 'Спланируйте входы, наряды и благословения.', 'Смешайте индийские ритмы с мизрахи, израильскими и актуальными хитами.', 'Подготовьте ясный переход от церемонии к танцам.'], cta: 'Создадим яркий, уважительный и энергичный саундтрек.' },
        henna_iraqi: { title: 'Иракская хина', sectionTitle: 'Музыкальное планирование иракской хины', description: 'Иракская хина теплая, семейная и основана на песнях, которые соединяют поколения.', imageAlt: 'Иракская хина с семьей и танцами', intro: 'Музыка должна дать место семейным песням, благословениям и кругам, а затем естественно перейти к празднику.', bullets: ['Соберите важные иракские и семейные песни.', 'Определите порядок входа, церемонии и кругов.', 'Смешайте иракскую, мизрахи и современную музыку.', 'Сделайте переход к танцам коротким и чистым.'], cta: 'Спланируем баланс между традицией, семьей и живым танцполом.' },
        henna_persian: { title: 'Персидская хина', sectionTitle: 'Как построить персидскую хину в правильном темпе', description: 'Персидская хина сочетает элегантность, семейную церемонию и радостную музыку.', imageAlt: 'Элегантная персидская хина с музыкой и радостью', intro: 'При правильном плане традиция получает свое место, а танцпол остается современным и радостным.', bullets: ['Выберите важные персидские песни для входов.', 'Спланируйте церемонию без длинных остановок.', 'Смешайте персидские, мизрахи, израильские и международные хиты.', 'Согласуйте ключевые моменты и переходы с DJ.'], cta: 'Сделаем вечер уважительным, радостным и плавным.' },
        bar_bat_recording: { title: 'Запись песен для бар/бат-мицвы', sectionTitle: 'Запись песни для бар или бат-мицвы', description: 'Записанная песня может сделать вход, клип или семейный момент особенно трогательным.', imageAlt: 'Микрофон и запись песни для бар или бат-мицвы', intro: 'Лучше всего работает личный текст и простая понятная идея.', bullets: ['Выберите подходящий минус.', 'Напишите короткий личный текст.', 'Оставьте время на репетицию.', 'Согласуйте момент включения песни.'], cta: 'Сделаем записанную песню аккуратной и эмоциональной.' },
        bar_bat_entrance: { title: 'Вход на бар/бат-мицву', sectionTitle: 'Как спланировать вход на бар или бат-мицву', description: 'Дайте ребёнку центральный момент без лишнего перегруза.', imageAlt: 'Трогательный вход на бар или бат-мицву', intro: 'Вход должен соответствовать ребёнку: драматичный, лёгкий, короткий или весёлый.', bullets: ['Выберите песню, которую ребёнок любит.', 'Решите, кто входит вместе.', 'Сделайте вход коротким и ясным.', 'Соедините его со следующим моментом.'], cta: 'Построим вход, который точно подходит ребёнку.' },
        bar_bat_timeline: { title: 'Тайминг бар/бат-мицвы', sectionTitle: 'Как построить тайминг бар или бат-мицвы', description: 'Тайминг балансирует вход, благословения, еду и танцпол.', imageAlt: 'План тайминга бар или бат-мицвы', intro: 'Важно держать подростков вовлечёнными и не потерять семью.', bullets: ['Определите вход, клип и еду.', 'Откройте танцпол вовремя.', 'Согласуйте игры с DJ.', 'Не делайте длинный блок речей.'], cta: 'Правильный тайминг держит энергию для всех возрастов.' },
        bar_bat_attractions: { title: 'Аттракции для бар/бат-мицвы', sectionTitle: 'Как выбрать аттракции', description: 'Аттракции должны подходить ребёнку, друзьям и семье.', imageAlt: 'Аттракции для бар или бат-мицвы', intro: 'Фото-зоны, танцоры и игры работают лучше всего, когда они связаны с ребёнком.', bullets: ['Выберите то, что ребёнок любит.', 'Проверьте возраст аудитории.', 'Не ломайте танцпол.', 'Лучше одна сильная идея.'], cta: 'Правильная аттракция делает событие личным.' },
        bar_bat_musicians: { title: 'Музыканты для бар/бат-мицвы', sectionTitle: 'Когда добавить музыкантов', description: 'Музыканты могут усилить вход, встречу гостей или семейный момент.', imageAlt: 'Музыканты на бар или бат-мицве', intro: 'Лучше всего работает короткий живой момент, который поддерживает молодую аудиторию.', bullets: ['Выберите инструмент по атмосфере.', 'Держите момент коротким.', 'Согласуйте звук с DJ.', 'Музыканты должны усиливать праздник.'], cta: 'Живой момент добавляет торжественность без тяжести.' },
        bar_bat_music: { title: 'Выбор музыки для бар/бат-мицвы', sectionTitle: 'Как выбрать музыку для бар или бат-мицвы', description: 'Музыка должна работать для подростков, родителей и старшей семьи одновременно.', imageAlt: 'Выбор музыки для бар или бат-мицвы', intro: 'Здесь несколько аудиторий: друзья хотят актуальные хиты, родители хотят уважительный вечер, а семья должна чувствовать себя частью праздника. Смешайте поп, хип-хоп, мизрахи, латынь, ностальгию, транс, техно и религиозную музыку при необходимости.', bullets: ['Спросите ребёнка о любимых артистах и стилях.', 'Узнайте, что любит семья.', 'Смешайте подростковые хиты и семейные моменты.', 'Подготовьте список нежелательных песен.'], cta: 'Хорошая музыка держит ребёнка в центре и соединяет семью.' },
        event_music: { title: 'Выбор музыки для события', sectionTitle: 'Как выбрать музыку для события', description: 'Музыка должна подходить аудитории, месту и цели вечера.', imageAlt: 'DJ планирует музыку для события', intro: 'Музыка события - это не только плейлист, а публика, цель, тайминг и энергия.', bullets: ['Определите аудиторию и атмосферу.', 'Выберите важные песни.', 'Оставьте место чтению публики.', 'Подготовьте список запретов.'], cta: 'Хороший план превращает фон в запоминающийся вечер.' },
        event_entrance: { title: 'Вход на событие', sectionTitle: 'Как спланировать вход на событие', description: 'Вход даёт вечеру ясное и праздничное начало.', imageAlt: 'Праздничный вход на событие', intro: 'Даже общее событие может выиграть от продуманного входа.', bullets: ['Выберите подходящую песню.', 'Решите, кто входит.', 'Согласуйте свет и объявление.', 'Держите вход коротким.'], cta: 'Хороший вход задаёт атмосферу.' },
        event_attractions: { title: 'Аттракции для события', sectionTitle: 'Как выбрать аттракции для события', description: 'Аттракции должны подходить аудитории, месту и цели вечера.', imageAlt: 'Аттракции на частном или деловом событии', intro: 'Они создают интерес и память, если подходят программе.', bullets: ['Подберите к аудитории.', 'Проверьте место и электричество.', 'Согласуйте время с DJ.', 'Поддерживайте поток события.'], cta: 'Хорошие аттракции добавляют ценность.' },
        event_musicians: { title: 'Музыканты для события', sectionTitle: 'Живые музыканты на событии', description: 'Музыканты добавляют присутствие встрече гостей или моменту пика.', imageAlt: 'Живые музыканты с DJ на событии', intro: 'Саксофон, скрипка или перкуссия должны поддерживать DJ.', bullets: ['Выберите по атмосфере.', 'Согласуйте репертуар.', 'Проверьте звук.', 'Используйте там, где эффект сильнее.'], cta: 'Живые музыканты дают событию впечатляющий слой.' },
        event_music_timeline: { title: 'План тайминга события', sectionTitle: 'Как построить тайминг события', description: 'Чёткий тайминг помогает вечеру идти плавно: встреча гостей, речи, ключевые моменты, еда и танцы.', imageAlt: 'Планирование тайминга события', intro: 'С понятным таймингом каждый поставщик знает, когда включаться, а DJ держит естественный ритм вечера.', bullets: ['Разделите событие на этапы.', 'Определите главные моменты заранее.', 'Оставьте запас на изменения.', 'Согласуйте всё с площадкой и поставщиками.'], cta: 'Построим тайминг под место, гостей, поставщиков и программу.' },
      },
    },
  
    // ─────────────────────────────────────────────────────────────
    // SEO FAQ — SERVICES
    // ─────────────────────────────────────────────────────────────
  
    menu: {
      sections: [
        { id: 'home', label: 'Главная' },
        { id: 'story', label: 'Моя история' },
        { id: 'gallery', label: 'Галерея' },
        { id: 'contact', label: 'Контакты' },
        { id: 'info', label: 'Подробнее' },
        { id: 'reviews', label: 'Отзывы' },
        { id: 'planning', label: 'Планирование' },
      ],
    },
  
    seo: {
      faq: {
        wedding: [
          {
            q: `Что включает услуга свадебного DJ {city}?`,
            a: `Услуга включает личную консультацию и создание саундтрека, подобранного специально для вас, профессиональное сопровождение на всём пути, точное чувство публики, качественные миксы и сочетание жанров, звук и энергию, которые гарантируют радостную свадьбу с самого первого момента и до последней песни.`,
          },
          {
            q: `Сколько стоит свадебный DJ {city}?`,
            a: `{city} Обычно цена находится в диапазоне ₪4,000–₪9,000, в зависимости от размера свадьбы, даты и оборудования.`,
          },
          {
            q: `Как выбрать свадебного DJ {city}?`,
            a: `Важно выбрать DJ с подтверждённым опытом свадеб, сильным чувством публики и личной химией с парой. Рекомендуется читать отзывы, смотреть видео с реальных мероприятий и чувствовать, что вас действительно понимают и смогут профессионально провести вечер.`,
          },
          {
            q: `Предоставляет ли DJ {city} также световое оборудование?`,
            a: `Большинство площадок уже включает базовое освещение для танцпола. Для желающих можно добавить продвинутое сценическое и дизайнерское освещение, адаптированное под характер события. Я работаю с ведущими поставщиками в этой сфере и предлагаю широкий выбор решений по свету и сценическому оформлению, с ценой в зависимости от выбранного комплекта.`,
          },
          {
            q: `Можно ли включить живых музыкантов в свадьбу {city}?`,
            a: `Конечно. Можно добавить живых музыкантов, таких как саксофонист, скрипач, перкуссионист или бузукист, чтобы создать особую и эмоциональную атмосферу.`,
          },
          {
            q: `Сколько времени DJ выступает на свадьбе?`,
            a: `Продолжительность выступления определяется заранее по таймингу мероприятия и может составлять от двух часов до неограниченного времени — в зависимости от пожеланий пары и развития события.`,
          },
          {
            q: `Знаком ли местный DJ {city} с площадками?`,
            a: `В большинстве случаев да. Знание местных площадок позволяет легко координироваться с персоналом, точно настраивать звук и свет под пространство и правильно готовиться к расписанию события — это улучшает ход вечера и делает всё более профессиональным.`,
          },
          {
            q: `Что входит в пакеты свадебного DJ {city}?`,
            a: `Базовый пакет включает приезд с профессиональным DJ-оборудованием и выступление на протяжении всего мероприятия. Дополнительные улучшения могут включать кастомные DJ-стойки, after-party сеты, пакеты для медленного танца, премиальные опции, специальные аттракции, живых музыкантов и многое другое — всё адаптируется под стиль вашего события.`,
          },
          {
            q: `Есть ли резервное оборудование?`,
            a: `Да, профессиональный DJ всегда приезжает с резервным оборудованием и планом на случай непредвиденной ситуации.`,
          },
          {
            q: `Как выбираются песни для церемонии?`,
            a: `Выбор песен происходит совместно с парой и подбирается индивидуально. Обычно это включает песню для выхода жениха, выхода невесты и момента разбивания бокала, а иногда и другие особые композиции. Процесс тщательно координируется, чтобы создать точный и эмоциональный момент.`,
          },
          {
            q: `За сколько времени стоит бронировать свадебного DJ {city}?`,
            a: `Минимум за шесть месяцев, а в высокий сезон рекомендуется даже за год.`,
          },
          {
            q: `Можно ли выбрать полный плейлист?`,
            a: `Конечно. Вы можете прислать полный список песен, любимые треки, песни, которые вы не хотите слышать, или общие музыкальные направления.`,
          },
          {
            q: `Какие свадебные аттракции самые популярные {city}?`,
            a: `Популярные аттракции включают холодные фейерверки, тяжёлый дым, лопающиеся шары, мыльные пузыри, сценический свет, живых музыкантов, конфетти и многое другое.`,
          },
        ],
  
        henna: [
          {
            q: `Что включает услуга DJ на хну {city}?`,
            a: `Услуга включает личную консультацию, индивидуальный саундтрек, профессиональное сопровождение на всём процессе, точное чувство публики, качественные миксы и сочетание жанров, звук и энергию, которые гарантируют радостный праздник хны от начала до конца.`,
          },
          {
            q: `Какие типы праздников хны существуют?`,
            a: `Существует множество стилей — марокканская, йеменская, персидская, тунисская и другие. На практике стили также можно комбинировать в соответствии с семейными традициями и атмосферой, которую вы хотите создать.`,
          },
          {
            q: `Как планируются выходы жениха и невесты на хне {city}?`,
            a: `Выходы планируются заранее, включая выбор музыки и точный тайминг переходов, чтобы создать впечатляющий и эмоциональный момент. Я сопровождаю вас в координации песен и времени с площадкой и семьёй.`,
          },
          {
            q: `Можно ли организованно спланировать саму церемонию хны?`,
            a: `Да. Порядок церемонии, музыка для ключевых моментов и переход к вечеринке согласовываются заранее, чтобы сохранять хороший ритм без падения энергии.`,
          },
          {
            q: `Как церемония вручения золотых подарков включается в хну?`,
            a: `Подбираются подходящие песни, тайминг согласовывается с семьёй и фотографами, а сам момент сохраняется уважительным и эмоциональным в соответствии с вашими предпочтениями.`,
          },
          {
            q: `Можно ли включить традиционную одежду в праздник хны {city}?`,
            a: `Конечно. Смена нарядов и тайминг планируются заранее, чтобы они органично вписывались в церемонию и фотосъёмку. Рекомендуется координация с площадкой или продюсером.`,
          },
          {
            q: `Сколько стоит DJ на хну {city}?`,
            a: `Обычно цены находятся в диапазоне ₪2,500–₪5,000 в зависимости от масштаба, даты, места проведения и дополнительных опций.`,
          },
          {
            q: `Как выбрать DJ на хну {city}?`,
            a: `Выбирайте DJ, который умеет чувствовать публику, сочетать стили, соответствующие традициям хны, и профессионально вести весь вечер.`,
          },
          {
            q: `Сколько времени DJ выступает на хне?`,
            a: `Продолжительность выступления определяется по расписанию и может варьироваться от нескольких часов до неограниченного времени.`,
          },
          {
            q: `Что входит в пакеты DJ на хну?`,
            a: `Базовый пакет включает профессиональное оборудование и выступление на протяжении всего мероприятия. Улучшения могут включать кастомные стойки, after-party сеты, премиальные пакеты, живых музыкантов и другое.`,
          },
          {
            q: `Можно ли включить барабанщиков или живых музыкантов в хну?`,
            a: `Да — можно включить барабанщиков, шофары, саксофон, скрипку или бузуки.`,
          },
          {
            q: `Какие аттракции для хны популярны {city}?`,
            a: `Популярные аттракции включают холодные фейерверки, тяжёлый дым, лопающиеся шары, пузыри, сценический свет, конфетти, барабанщиков, магнитных фотографов, коктейльные бары и многое другое.`,
          },
          {
            q: `Предоставляет ли DJ {city} также световое оборудование?`,
            a: `Большинство площадок включает базовое освещение. При желании можно добавить продвинутый световой дизайн.`,
          },
          {
            q: `Как строится плейлист для хны?`,
            a: `Музыкальные направления определяются заранее вместе с вами, включая любимые песни и треки, которых стоит избегать, а музыка в реальном времени подстраивается под публику.`,
          },
          {
            q: `Можно ли выбрать полный плейлист?`,
            a: `Да — вы можете прислать полный список, любимые треки, список “не ставить” или общие музыкальные направления.`,
          },
          {
            q: `Как вы адаптируете музыку для разной аудитории на хне?`,
            a: `Через чувство публики в реальном времени и умное смешивание стилей, эпох и ритмов.`,
          },
          {
            q: `Что стоит проверить в договоре с DJ?`,
            a: `Проверьте, что включено, часы работы, возможности продления, условия отмены, требования площадки и наличие резервного оборудования.`,
          },
          {
            q: `Есть ли резервное оборудование?`,
            a: `Да, профессиональный DJ приезжает полностью подготовленным, с резервным оборудованием и планами на случай непредвиденных ситуаций.`,
          },
        ],
        bar_bat: [
          {
            q: `Что включает услуга DJ на Бар/Бат-мицву {city}?`,
            a: `Услуга включает личную консультацию и создание саундтрека, подобранного специально для вас, профессиональное сопровождение на всём процессе, точное чувство публики, качественные миксы и сочетание жанров, звук и энергию, которые гарантируют радостную Бар/Бат-мицву с первого момента и до последней песни.`,
          },
          {
            q: `Как спланировать впечатляющий выход именинника на Бар/Бат-мицве {city}?`,
            a: `Планирование выхода включает выбор песни, точный тайминг и расстановку аудитории или семьи, иногда в сочетании со спецэффектами. Цель — создать мощный момент, который поднимет энергию и задаст атмосферу.`,
          },
          {
            q: `Можно ли включить речи или благословения во время Бар/Бат-мицвы {city}?`,
            a: `Да. Тайминг согласовывается заранее, предоставляются подходящие микрофоны и обеспечивается чистый звук, чтобы момент органично вписался в событие и не нарушил его поток.`,
          },
          {
            q: `Как удерживать танцпол активным и для детей, и для взрослых на Бар/Бат-мицве?`,
            a: `За счёт правильного построения сета — сегменты для молодёжи с актуальными хитами לצד музыки, подходящей всей семье. Чувство публики в реальном времени помогает удерживать танцпол активным.`,
          },
          {
            q: `Как управлять подростковым танцполом, чтобы он не терял энергию?`,
            a: `Через музыкальную непрерывность, плавные переходы между жанрами и адаптацию к энергии публики — усиливая интенсивность, когда нужно, и балансируя, когда это необходимо.`,
          },
          {
            q: `Можно ли включить игры или интерактивные активности как часть вечеринки?`,
            a: `Да, по вашему желанию. Можно добавить ведущих, танцоров или интерактивные активности в соответствии со стилем именинника и аудиторией.`,
          },
          {
            q: `Сколько стоит DJ на Бар/Бат-мицву {city}?`,
            a: `Обычно цены находятся в диапазоне ₪2,500–₪4,500 в зависимости от масштаба мероприятия, площадки и выбранных дополнений.`,
          },
          {
            q: `Как выбрать DJ на Бар/Бат-мицву {city}?`,
            a: `Выбирайте DJ с опытом работы с молодой аудиторией, который умеет чувствовать публику и сочетать современную музыку с песнями, подходящими всем поколениям.`,
          },
          {
            q: `Как выбираются песни для Бар/Бат-мицвы?`,
            a: `Именинник заранее выбирает любимые песни и музыкальные направления, а DJ адаптирует музыку во время мероприятия בהתאם атмосфере.`,
          },
          {
            q: `Сколько времени DJ выступает на Бар/Бат-мицве?`,
            a: `Продолжительность выступления определяется по таймингу и может варьироваться от нескольких часов до неограниченного времени.`,
          },
          {
            q: `Что входит в пакеты DJ на Бар/Бат-мицву?`,
            a: `Базовый пакет включает профессиональное DJ-оборудование и выступление на протяжении всего мероприятия, с опциональными улучшениями, такими как кастомные стойки, after-party, аттракции и живые музыканты.`,
          },
          {
            q: `Можно ли включить танцоров или ведущих в Бар/Бат-мицву?`,
            a: `Да — танцоры, ведущие и интерактивные артисты могут усилить энергию и вовлечённость аудитории.`,
          },
          {
            q: `Какие аттракции для Бар/Бат-мицвы популярны {city}?`,
            a: `Популярные аттракции включают холодные фейерверки, тяжёлый дым, лопающиеся шары, генераторы пузырей, сценический свет, живых музыкантов, конфетти, магнитных фотографов, коктейльные бары и многое другое.`,
          },
          {
            q: `Предоставляет ли DJ {city} также световое оборудование?`,
            a: `Большинство площадок включает базовое освещение. При желании можно добавить продвинутый световой дизайн.`,
          },
          {
            q: `Как вы адаптируете музыку для разной аудитории на Бар/Бат-мицве?`,
            a: `Через чувство публики в реальном времени и сочетание актуальных хитов с песнями, которые любят и молодёжь, и взрослые.`,
          },
          {
            q: `Можно ли выбрать полный плейлист?`,
            a: `Да — вы можете предоставить полный список, любимые треки или общие направления, а DJ адаптирует музыку в реальном времени.`,
          },
          {
            q: `Что стоит проверить в договоре с DJ?`,
            a: `Проверьте, что включено, часы работы, возможности продления, условия отмены, требования площадки и наличие резервного оборудования.`,
          },
          {
            q: `Есть ли резервное оборудование?`,
            a: `Да, профессиональный DJ приезжает с резервным оборудованием и планами на случай непредвиденных ситуаций.`,
          },
          {
            q: `За сколько времени стоит бронировать DJ на Бар/Бат-мицву?`,
            a: `Рекомендуется бронировать минимум за 3–6 месяцев, а на популярные даты — ещё раньше.`,
          },
          {
            q: `Можно ли включить видео или презентации в Бар/Бат-мицву?`,
            a: `Да, экраны можно использовать для показа клипов, презентаций и личных фотографий במהלך мероприятия.`,
          },
        ],
  
        event: [
            {
              q: `Что включает услуга DJ для корпоративного или частного мероприятия {city}?`,
              a: `Услуга включает личную консультацию, создание индивидуального саундтрека, профессиональное сопровождение, точное чувство публики, качественные миксы и сочетание жанров, звук и энергию, которые гарантируют успешное мероприятие от начала до конца.`,
            },
            {
              q: `Сколько стоит DJ на мероприятие {city}?`,
              a: `Обычно цены находятся в диапазоне ₪2,000–₪5,000 в зависимости от типа мероприятия, масштаба, площадки и выбранных дополнений.`,
            },
            {
              q: `Как выбрать DJ для мероприятия?`,
              a: `Выбирайте DJ с опытом, сильным чувством публики, проверенными отзывами и музыкальным стилем, подходящим вашему событию.`,
            },
            {
              q: `Сколько времени DJ выступает на мероприятии?`,
              a: `Продолжительность выступления определяется заранее и может варьироваться от нескольких часов до неограниченного времени.`,
            },
            {
              q: `Что входит в пакеты DJ для мероприятий?`,
              a: `Базовый пакет включает профессиональное оборудование и выступление на протяжении всего мероприятия, с возможностью добавления кастомных стоек, after-party, аттракций и живых музыкантов.`,
            },
            {
              q: `Подходит ли DJ для небольших мероприятий?`,
              a: `Да — услуга легко адаптируется как для камерных встреч, так и для масштабных событий.`,
            },
            {
              q: `Предоставляет ли DJ {city} также световое оборудование?`,
              a: `Большинство площадок включает базовое освещение. Дополнительно можно заказать продвинутое световое и сценическое оформление.`,
            },
            {
              q: `Какие аттракции популярны для мероприятий {city}?`,
              a: `Популярные аттракции включают холодные фейерверки, тяжёлый дым, лопающиеся шары, мыльные пузыри, сценический свет, живых музыкантов, конфетти, барабанщиков, магнитных фотографов, коктейльные бары и многое другое.`,
            },
            {
              q: `Можно ли проводить мероприятие на открытом воздухе или в нестандартной локации?`,
              a: `Да — мероприятия на пляже или в саду возможны, но требуют специальной подготовки звука, света и оборудования.`,
            },
            {
              q: `Как вы адаптируете музыку под разную аудиторию на мероприятии?`,
              a: `Через чувство публики в реальном времени и грамотное сочетание жанров и эпох, чтобы удерживать танцпол активным.`,
            },
            {
              q: `Можно ли выбрать полный плейлист?`,
              a: `Да — вы можете прислать список песен или музыкальные направления, а DJ адаптирует сет под аудиторию.`,
            },
            {
              q: `Можно ли добавить живых музыкантов или выступления?`,
              a: `Да — можно добавить саксофониста, скрипача, барабанщика и других артистов.`,
            },
            {
              q: `За сколько времени стоит бронировать DJ?`,
              a: `Рекомендуется бронировать минимум за 3–6 месяцев, а на популярные даты — ещё раньше.`,
            },
            {
              q: `Что стоит проверить в договоре с DJ?`,
              a: `Проверьте включённые услуги, часы работы, условия продления, условия отмены и наличие резервного оборудования.`,
            },
            {
              q: `Есть ли резервное оборудование?`,
              a: `Да, профессиональные DJ всегда приезжают с резервным оборудованием.`,
            },
            {
              q: `Можно ли включить видео или презентации в мероприятие?`,
              a: `Да, можно использовать экраны для показа видео, презентаций и персонального контента.`,
            },
          ],
    
          homeEvent: [
            {
              q: `Что включает услуга DJ для мероприятия?`,
              a: `Услуга включает личную консультацию, индивидуальный саундтрек, профессиональное сопровождение, точное чувство публики, качественные миксы и сочетание жанров, звук и энергию, которые гарантируют успешное мероприятие от начала до конца.`,
            },
            {
              q: `Сколько стоит DJ на мероприятие?`,
              a: `Обычно цены находятся в диапазоне ₪2,000–₪5,000 в зависимости от типа мероприятия, масштаба, места проведения и дополнительных опций.`,
            },
            {
              q: `На каких мероприятиях вы выступаете как DJ?`,
              a: `Свадьбы, праздники хны, Бар/Бат-мицвы, корпоративные мероприятия, вечеринки для сотрудников, тимбилдинги, частные вечеринки и семейные события.`,
            },
            {
              q: `Как вы адаптируете музыку под аудиторию?`,
              a: `Через чувство публики в реальном времени и сочетание жанров, эпох и темпа, чтобы удерживать танцпол живым.`,
            },
            {
              q: `Вы предоставляете своё DJ и звуковое оборудование?`,
              a: `Да — я приезжаю с профессиональным DJ-оборудованием, включая колонки, микшер и микрофоны, адаптированные под площадку.`,
            },
            {
              q: `Можно ли добавить освещение?`,
              a: `Большинство площадок включает базовое освещение. Дополнительно можно заказать продвинутый световой дизайн.`,
            },
            {
              q: `За сколько времени стоит бронировать DJ?`,
              a: `Рекомендуется бронировать за несколько месяцев, особенно на популярные даты.`,
            },
            {
              q: `Подходит ли DJ для небольших и камерных мероприятий?`,
              a: `Конечно — уровень звука, стиль музыки и атмосфера адаптируются под формат мероприятия.`,
            },
            {
              q: `Как выбрать DJ для мероприятия?`,
              a: `Проверьте опыт, отзывы, видео с мероприятий, музыкальный стиль и личный контакт.`,
            },
            {
              q: `Что включают пакеты и дополнительные опции?`,
              a: `Базовый пакет включает DJ-оборудование и выступление, с возможностью добавления кастомных стоек, after-party, аттракций и живых музыкантов.`,
            },
            {
              q: `Какие аттракции популярны для мероприятий?`,
              a: `Холодные фейерверки, тяжёлый дым, шары, пузыри, свет, музыканты, конфетти и многое другое.`,
            },
            {
              q: `Есть ли резервное оборудование в случае поломки?`,
              a: `Да — профессиональные DJ всегда приезжают с резервным оборудованием.`,
            },
            {
              q: `Вы выступаете на корпоративных мероприятиях и тимбилдингах?`,
              a: `Да — музыка адаптируется под организацию и аудиторию.`,
            },
            {
              q: `Как формируется плейлист для мероприятия?`,
              a: `Мы заранее определяем музыкальные направления, ключевые треки и предпочтения, после чего создаётся динамичный сет.`,
            },
            {
              q: `Можно ли отправить список песен заранее?`,
              a: `Конечно — вы можете отправить список обязательных треков и тех, которые не хотите слышать.`,
            },
            {
              q: `Что происходит, если мероприятие длится дольше?`,
              a: `Выступление можно продлить по договорённости с дополнительной оплатой.`,
            },
            {
              q: `Проводится ли координация перед мероприятием?`,
              a: `Да — рекомендуется встреча или звонок для обсуждения сценария, музыки и ключевых моментов.`,
            },
          ],
        },
      },
    
      geo: {
        regions: {
          דרום: 'Юг',
          מרכז: 'Центр',
        },
    
        cities: {
          'באר שבע': "Беэр-Шева",
          'אשקלון': 'Ашкелон',
          'אשדוד': 'Ашдод',
          'קריית גת': 'Кирьят-Гат',
          'אופקים': 'Офаким',
          'נתיבות': 'Нетивот',
          'שדרות': 'Сдерот',
          'להבים': 'Лехавим',
          'עומר': 'Омер',
          'דימונה': 'Димона',
          'קריית מלאכי': 'Кирьят-Малахи',
          'ערד': 'Арад',
          'ירוחם': 'Йерухам',
          'מיתר': 'Митар',
          'אילת': 'Эйлат',
          'קריית עקרון': 'Кирьят-Экрон',
          'גן יבנה': 'Ган-Явне',
    
          'תל אביב': 'Тель-Авив',
          'רמת גן': 'Рамат-Ган',
          'גבעתיים': 'Гиватаим',
          'ראשון לציון': 'Ришон-ле-Цион',
          'חולון': 'Холон',
          'בת ים': 'Бат-Ям',
          'רעננה': 'Раанана',
          'הרצליה': 'Герцлия',
          'פתח תקווה': 'Петах-Тиква',
          'יבנה': 'Явне',
          'רחובות': 'Реховот',
          'נס ציונה': 'Нес-Циона',
          'כפר סבא': 'Кфар-Саба',
          'הוד השרון': 'Ход-ха-Шарон',
          'מודיעין': 'Модиин',
          'ראש העין': 'Рош-ха-Аин',
          'נתניה': 'Нетания',
          'חדרה': 'Хадера',
          'עמק חפר': 'Эмек-Хефер',
        },
    
        globalLabel: 'Израиль',
      },
    } as const;
    
    export type RuPack = typeof ru;
